// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb
import { initHdDropdownTracking, initVideoTracking, setMobileCSSCustomProperties, sendAnalyticsEvent } from '../helpers/util'
import { initBatchQuotesFromIR, initSimilarProductsSection, setupBatchQuotesSkeleton } from '../modules/BatchQuotes'
import { initCompanyPage } from '../modules/Company'
import { initCompanyFeatures } from '../modules/Company/prospect'
import { downloadIrSetup } from '../modules/DownloadInfoRequest'
import { bimSetup } from '../modules/LightBim'
import { initProductAvailabilityToaster, initProductPage, optimizeGalleryImagesAtBottom, seeMoreDownloadFiles } from '../modules/Products'
import { initGallery } from '../modules/Gallery'
import { popover } from '../helpers/popover'

document.addEventListener('DOMContentLoaded', () => {
  const referrerField = document.querySelector('.referrer')
  if (referrerField) referrerField.value = document.referrer // Set HTTP referer

  const productSinglePage = document.getElementById('product-single')
  if (productSinglePage) {

    if (afdDevice === 'phone') {
      const relatedProducts = document.querySelectorAll('.js-bottom-widget-item')
      const eventArgs = { type: 'event', category: 'related-product', action: 'click' }

      relatedProducts.forEach(product => {
        product.addEventListener('click', () => sendAnalyticsEvent({ ...eventArgs, label: 'Open a Related Product from mobile version' }))
      })
    }

    if (['cl', 'us', 'br', 'mx'].includes(NFT.site)) optimizeGalleryImagesAtBottom()
    seeMoreDownloadFiles()
    initProductPage()
    initHdDropdownTracking()
    popover()
  }

  setMobileCSSCustomProperties()
  bimSetup();
  downloadIrSetup();
  initProductAvailabilityToaster()

  if (document.getElementById('info-request-batch')) {
    // For Google Ads - Remarketing MVP - CO only
    if (NFT.site === 'co' && window.gtag) {
      window.gtag('event', 'conversion', { 'send_to': 'AW-711626698/zdoWCO2OwNEBEMqfqtMC' });
    }
    initSimilarProductsSection()
    initBatchQuotesFromIR()
  }
  // Init company page
  if (document.getElementById('companies-wrap')) {
    initCompanyFeatures();
  }

  initCompanyPage();

  initVideoTracking();

  initGallery();

});

// Setting the height of js-masonry container
window.addEventListener('load', () => {
  setupBatchQuotesSkeleton();
});
